// Alignment of dots grid on media background
document.addEventListener( "DOMContentLoaded", () => {
	document.querySelectorAll('.cta-media-text').forEach( node => {
		var content  = node.querySelector('.cta-media-text__content')
		var media    = node.querySelector('.cta-media-text__media')
		var imageDot = media.querySelector('.image-dots')

		imageDot.style.height = content.offsetHeight + 'px';
		imageDot.style.top    = content.offsetTop + 'px';
	});
});

//animation
document.querySelectorAll('.cta-media-text').forEach( node => {
	const kicker         = node.querySelector('.cta-media-text__kicker');
	const title          = node.querySelector('.cta-media-text__title');
	const intro          = node.querySelector('.cta-media-text__intro');
	const subscribeTitle = node.querySelector('.subscribe-block__title');
	const subscribeBlock = node.querySelector('.subscribe-block__columns');
	const button         = node.querySelector('.wp-block-button');

	if ( kicker ) {
		kicker.dataset.animation      = 'block';
		kicker.dataset.animationDelay = '200';
	}

	if ( title ) {
		title.dataset.animation      = 'block';
		title.dataset.animationDelay = '400';
	}

	if ( intro ) {
		intro.dataset.animation      = 'block';
		intro.dataset.animationDelay = '600';
	}

	if ( button ) {
		button.dataset.animation      = 'block';
		button.dataset.animationDelay = intro ? '1200' : '600';
	}

	if ( subscribeTitle ) {
		subscribeTitle.dataset.animation      = 'lines';
		subscribeTitle.dataset.animationDelay = '1000';
	}

	if ( subscribeBlock ) {
		subscribeBlock.dataset.animation      = 'block';
		subscribeBlock.dataset.animationDelay = '1000';
	}

	const image = node.querySelector('.cta-media-text__background-media');

	if ( image ) {
		image.dataset.animation = 'image';
		image.dataset.animationDelay = '400';
	}

	const foregroundImage = node.querySelector('.cta-media-text__foreground-media');

	if ( foregroundImage ) {
		foregroundImage.dataset.animation = 'image';
		foregroundImage.dataset.animationDelay = '400';
	}
} );
